export enum ExportButtonEnum {
  StatisticMemberRegisterExport = 'statisticMemberRegisterExport',
  SmsBillingReportExport = 'smsBillingReportExport',
}
